import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import {
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  Card,
  CardContent,
  CardActions,
  Typography,
  Divider,
  Box,
  Button,
  IconButton,
  Toolbar,
  AppBar,
  Dialog,
  ListItemText,
  ListItem,
  List,
  Tabs,
  Tab,
  Slide,
  Paper,
  Grid,
} from '@material-ui/core';
import MaterialTable, { MTableToolbar } from 'material-table';
import { issues } from './../../../data';
import EditTwoToneIcon from '@material-ui/icons/EditTwoTone';
import DeleteTwoToneIcon from '@material-ui/icons/DeleteTwoTone';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import * as settingLabelManageAction from '../../../actions/settingLabelManage.action';
import { useDispatch, useSelector } from 'react-redux';

// import react-router
import { Link } from 'react-router-dom';

// import Formik and Dependency
import { Formik, Form, Field } from 'formik';
import { Select, TextField } from 'formik-material-ui';
import * as Yup from 'yup';
import SelectPersonalDataCategory from '../../fragments/SelectPersonalDataCategory';
import SelectMultiPersonalDataCategory from '../../fragments/SelectMultiPersonalDataCategory';
import globalStyles from '../../../styles/globalStyles';
import SelectPermissionLevel from '../../fragments/SelectPermissionLevel';
import SelectNameOrEmail from '../../fragments/SelectNameOrEmail';
import SelectDepartment from '../../fragments/SelectDepartment';
import { ColorPicker } from 'material-ui-color'; //https://mikbry.github.io/material-ui-color/?path=/story/docs-intro--page
import { Backdrops } from './../../fragments/Loading/react-loadingg';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //backgroundColor: theme.palette.background.paper,
  },
  appBar: {
    position: 'relative',
    // backgroundColor: theme.palette.background.paper,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));
const paletteObj = {
  red: '#ff0000',
  blue: '#0000ff',
  green: '#00ff00',
  yellow: 'yellow',
  cyan: 'cyan',
  lime: 'lime',
  gray: 'gray',
  orange: 'orange',
  purple: 'purple',
  black: 'black',
  white: 'white',
  pink: 'pink',
  darkblue: 'darkblue',
};
const styles = (theme) => ({
  ...globalStyles(theme),
  root: {
    flexGrow: 1,
    //backgroundColor: theme.palette.background.paper,
  },
  appBar: {
    position: 'relative',
    backgroundColor: theme.palette.primary.dark,
  },
  appBarTab: {
    backgroundColor: theme.palette.primary.light,
    color: '#222',
  },
  title: {
    //marginLeft: theme.spacing(2),
    flex: 1,
  },
  TabPanel: {
    padding: theme.spacing(1),
  },
  menuButton: {
    marginLeft: theme.spacing(1),
  },
  toolbar: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1, 0, 1, 0),
  },
  card: {
    minWidth: 500,
    padding: theme.spacing(0, 2, 3, 2),
  },
  cardContent: {
    minHeight: 500,
  },
  section: {
    margin: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(1),
  },
  tableHeight: {
    body: { minHeight: '10px !important' },
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const TabPanel = (props) => {
  const { children, value, index, classes, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`setting-permission-tabpanel-${index}`}
      aria-labelledby={`setting-permission-tab-${index}`}
      {...other}
      style={{ minHeight: 250, padding: 5 }}
    >
      {<Box component="div">{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `setting-permission-tab-${index}`,
    'aria-controls': `setting-permission-tabpanel-${index}`,
  };
}



// Show from reporting breach
const FormSettingLabel = ({
  values,
  setFieldValue,
  touched,
  errors,
  classes,
  actionStatus,
  handleClose,
  isSubmitting,
}) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();
  const SettingPermissionSaveReducer = useSelector(
    ({ SettingPermissionSaveReducer }) => SettingPermissionSaveReducer
  );

  const [categoryValue, setCategoryValue] = React.useState([]);
  // const [userValue, setUserValue] = React.useState([]);
  const [userData, setUserData] = React.useState([]);
  const [lblName, setLblName] = React.useState(actionStatus.action=='add'?'':values.labelName);
  let defaultColorPicker = {
    backgroundColor: '#fff',
    color: '#000',
  };

  if(actionStatus.action=='edit'){
    let editStyle=null;
    try {
      editStyle = values.labelStyles==null?defaultColorPicker:values.labelStyles;
    }catch(e){
      editStyle = defaultColorPicker;
    }
    defaultColorPicker = editStyle;
  }

  const [colorPicker, setColorPicker] = React.useState(defaultColorPicker);
  const [initColorPicker, setInitColorPicker] = React.useState(defaultColorPicker);
  
  let labelSave = 'บันทึก';
  let labelCancel = 'ยกเลิก';
  let labelName = 'ชื่อป้ายกำกับระดับ 1 / ชื่อป้ายกำกับระดับ 2 (ถ้ามี)';
  let labelDescription = 'คำอธิบาย';
  let columnName = [
    {
      title: 'รูปภาพ',
      field: 'image',
      render: (rowData) => (
        <>
          <img src={rowData.image} style={{ width: 40, borderRadius: '90%' }} />
        </>
      ),
    },
    { title: 'ชื่อ-นามสกุล', field: 'fullName' },
    { title: 'อีเมล', field: 'email' },
  ];

  const handleChangeColor = (color, isFont) => {
    // console.log(color);
    // console.log(color.hex);
    let newColor = null;
    if (isFont) {
      newColor = {
        backgroundColor: colorPicker.backgroundColor,
        color: '#' + color.hex,
      };
    } else {
      newColor = {
        backgroundColor: '#' + color.hex,
        color: colorPicker.color,
      };
    }

    setColorPicker(newColor);
    setFieldValue('labelStyles', newColor);
  };
  
  useEffect(() => {
    if(actionStatus.action=="add"){
       setFieldValue('labelStyles', defaultColorPicker);
      
    }else{
      setFieldValue('labelStyles', values.labelStyles);
    
    }
  }, [])
  
  //Reference of material-table
  const tableRef = useRef();
  return (
    <div>
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            className={classes.menuButton}
          >
            {actionStatus.action == 'add' ? <AddIcon /> : <EditTwoToneIcon />}
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {actionStatus.label}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Form autoComplete="off">
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <CardActions style={{ justifyContent: 'flex-end' }}>
              <Button variant="contained" color="primary" type="submit">
                {labelSave}
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  handleClose();
                }}
              >
                {labelCancel}
              </Button>
            </CardActions>

            <Paper className={classes.paper} elevation={0}>
              <Grid container spacing={1}>
                <Grid item xs={12} xl={12}>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    error={false}
                  >
                    <Field
                      component={TextField}
                      name="labelName"
                      type="text"
                      //value={values.labelName}
                     // defaultValue={values.labelName}
                      label={labelName + ' *'}
                      onKeyUp={(e) => {
                        setLblName(e.target.value);
                      }}
                    />
                  </FormControl>

                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    error={false}
                  >
                    <Field
                      component={TextField}
                      name="labelDescription"
                      type="text"
                      label={labelDescription}
                      //value={values.labelDescription}
                      //defaultValue={values.labelDescription}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} xl={12} md={6} xl={6} lg={6}>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    error={false}
                    readOnly
                  >
                    <div>
                      <span>สีตัวอักษร</span>
                      <ColorPicker
                        defaultValue="transparent"
                        onChange={(c) => handleChangeColor(c, true)}
                        value={colorPicker.color}
                        palette={paletteObj}
                       // hideTextfield
                       
                      />
                    </div>

                    <div>
                      <span>สีพื้นหลัง</span>
                   
                      <ColorPicker
                        defaultValue="transparent"
                        onChange={(c) => handleChangeColor(c, false)}
                        value={colorPicker.backgroundColor}
                        palette={paletteObj}
                       
                       // hideTextfield
                      
                       
                      />
                    
                    </div>
                  </FormControl>
                  <FormControl
                    fullWidth
                    className={classes.formControl}
                    error={false}
                  >
                    {/* <ColorPicker
                  name="color"
                  //defaultValue='#000'
                  value={colorPicker}
                  onChange={handleChangeColor}
                /> */}

                    <div style={{ marginTop: 5 }}>
                      <Button
                        color="primary"
                        onClick={() => setColorPicker(initColorPicker)}
                      >
                        Reset
                      </Button>
                    </div>
                  </FormControl>
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  xl={12}
                  md={6}
                  xl={6}
                  lg={6}
                  style={{ border: '1px solid #ccc' }}
                >
                  <Grid
                    item
                    style={{ textAlign: 'center' }}
                    xs={12}
                    xl={12}
                    md={12}
                    xl={12}
                    lg={12}
                  >
                    <h4 style={{ fontWeight: 'bold', margin: 'auto' }}>
                      ตัวอย่างการแสดงผล ชื่อป้ายกำกับ
                    </h4>
                  </Grid>
                  <Grid
                    item
                    style={{ textAlign: 'center' }}
                    xs={12}
                    xl={12}
                    md={12}
                    xl={12}
                    lg={12}
                  >
                    <h1 style={colorPicker}>{lblName}</h1>
                    {/* <h2 style={colorPicker}>{lblName}</h2>
                    <h3 style={colorPicker}>{lblName}</h3> */}
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Form>
    </div>
  );
};
const FormSettingLabels = React.memo(withStyles(styles)(FormSettingLabel));

const SettingLabelManagePage = (props) => {
  const {
    open,
    setOpen,
    classes,
    actionStatus,
    keyValues,
    setFieldValue,
    touched,
    errors,
    isSubmitting,

    ...rest
  } = props;
  //const classes = useStyles();
 // YUP: build validation schema (validationSchema)
const categoryData = Yup.object({
  value: Yup.number().required('Required'),
  label: Yup.string().required('Required'),
});

const validationSchema = Yup.object().shape({
  labelName: Yup.string().required('กรุณาระบุชื่อป้ายกำกับ'),
  // departmentId: Yup.string().required('กรุณาระบุส่วนงาน'),
  // permissionLevel_id: Yup.string().required('กรุณาระบุระดับการดำเนินการ'),
  // // user_id: Yup.bool().required('กรุณาระบุผู้ใช้งาน').oneOf([true], "กรุณาระบุผู้ใช้งาน"),
  // permissionGroupName: Yup.string().required('กรุณาระบุกลุ่มสิทธิ์ผู้ใช้งาน'),
  /*summary: Yup.string()
    .min(4, 'เรื่องโดยสรุปต้องมากกว่า 4 อักขระ')
    .max(255, 'เรื่องโดยสรุปต้องไม่เกิน 255 อักขระ')
    .required('กรุณากรอกเรื่องโดยสรุป'),
  description: Yup.string()
    .min(4, 'รายละเอียดต้องมากกว่า 4 อักขระ')
    .max(255, 'รายละเอียดต้องไม่เกิน 1000 อักขระ')
    .required('กรุณากรอกรายละเอียด'),*/
  //fullname: Yup.string().required('กรุณาเลือกหมวดหมุ่ข้อมูลส่วนบุคคล'),
});

// InitialVaue of form reporting breach
let initialValues = {
  labelId: '',
  labelName: '',
  labelDescription: '',
  labelStyles: '',
};
  
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  
  };
  //const [fullWidth, setFullWidth] = React.useState(true);
  //const [maxWidth, setMaxWidth] = React.useState('xl');
  const dispatch = useDispatch();
  const SettingPermissionSaveReducer = useSelector(
    ({ SettingPermissionSaveReducer }) => SettingPermissionSaveReducer
  );

  const SettingLabelManageByIdReducer = useSelector(
    ({ SettingLabelManageByIdReducer }) => SettingLabelManageByIdReducer
  );

  const loadSettingLabelById = () => {
    dispatch(
      settingLabelManageAction.loadSettingLabelById(keyValues)
    )

  };

  useEffect(() => {
    if(actionStatus.action == 'add'){
    
      initialValues = {
        labelId: '',
        labelName: '',
        labelDescription: '',
        labelStyles: '',
      };
    }

});

  useEffect(() => {
    if (actionStatus.action == 'edit') {
      loadSettingLabelById();
    }
  }, []);

   /* สามารถ get ค่าได้รอบที่2 */
  
   let labelData = SettingLabelManageByIdReducer.result.content;
   if(labelData!=undefined && actionStatus.action == 'edit'){
    initialValues = {
      labelId: labelData.id,
      labelName: labelData.name,
      labelDescription: labelData.description?labelData.description:'',
      labelStyles: labelData.style!=null ?JSON.parse(labelData.style):null,
    };
  }

 
  return (
    <div>
      {
        <Backdrops
          open={
            SettingLabelManageByIdReducer.isFetching == null
              ? false
              : SettingLabelManageByIdReducer.isFetching
          }
        />
      }

      {actionStatus.action == 'add' ||
      (actionStatus.action == 'edit' &&
        SettingLabelManageByIdReducer.isFetching == false) ? (
        <Dialog
          open={open}
          fullScreen={fullScreen}
          fullWidth={true}
          maxWidth={'md'}
          onClose={handleClose}
          TransitionComponent={Transition}
          disableBackdropClick={true}
        >
          <Formik
            validationSchema={validationSchema}
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              let data = {
                labelType_id : 0,
                name:values.labelName,
                description:values.labelDescription=''?null:values.labelDescription,
                style: JSON.stringify(values.labelStyles),
              };

              if (actionStatus.action == 'edit') {
                data['id'] = keyValues;
              }

              dispatch(
                actionStatus.action == 'add'
                  ? settingLabelManageAction.saveSettingLabel(data)
                  : settingLabelManageAction.editSettingLabel(data)
              ).then(() => {
                setSubmitting(false);
                setOpen(false);
                rest.reloadTable();
              });


            }}
          >
            {({ values, setFieldValue, touched, errors, isSubmitting }) => (
              <FormSettingLabels
                actionStatus={actionStatus.label}
                handleClose={handleClose}
                errors={errors}
                touched={touched}
                values={values}
                setFieldValue={setFieldValue}
                isSubmitting={isSubmitting}
                {...props}
              />
            )}
          </Formik>
        </Dialog>
      ) : null}
    </div>
  );
};
export default React.memo(withStyles(styles)(SettingLabelManagePage));
